import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { PricingPage } from "@/features/billing";

// `?payment=<uuid>` — возврат со страницы платёжного сервиса: окно оплаты показывает статус
// этого платежа. Неверное значение просто пропадает.
const pricingSearchSchema = z.object({
  payment: z.uuid().optional().catch(undefined),
});

const PricingRoute = () => {
  const { payment } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <PricingPage
      returnedPaymentId={payment ?? null}
      onCheckoutClosed={() => {
        void navigate({ search: {}, replace: true });
      }}
    />
  );
};

// «Тарифы» открываются без входа (`staticData.isPublic`): их проверяет модерация платёжного
// сервиса, а ссылка на них есть в подвале.
export const Route = createFileRoute("/pricing")({
  validateSearch: pricingSearchSchema,
  staticData: { isPublic: true },
  component: PricingRoute,
});
